import { useTranslation } from 'hooks/useTranslation';
import { useOvertimeDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/OvertimeDashboard/store/overtimeDashboard.store';
import { KpiStatCardProps } from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCard';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';
import { buildCohortGatedCard } from 'pages/ReportsPage/components/AnalyticsDashboards/kpiCardBuilders';
import { formatPayPeriodRangeLabel } from 'pages/ReportsPage/components/AnalyticsDashboards/payPeriodFormatters';

export function useOvertimeKpiCards(): KpiStatCardProps[] {
  const { i18n } = useTranslation();
  const totalOtHours = useOvertimeDashboardStore((s) => s.totalOtHours);
  const totalOtHoursChangePrct = useOvertimeDashboardStore((s) => s.totalOtHoursChangePrct);
  const totalOtHoursError = useOvertimeDashboardStore((s) => s.totalOtHoursError);
  const otRate = useOvertimeDashboardStore((s) => s.otRate);
  const otRateChangePrct = useOvertimeDashboardStore((s) => s.otRateChangePrct);
  const otRateError = useOvertimeDashboardStore((s) => s.otRateError);
  const isCohortSelected = useOvertimeDashboardStore((s) => s.isCohortSelected);
  const priorPeriodRange = useOvertimeDashboardStore((s) => s.priorPeriodRange);

  const comparisonText = priorPeriodRange
    ? `vs. ${formatPayPeriodRangeLabel(priorPeriodRange, i18n.language)}`
    : undefined;

  const totalOtHoursCard = buildCohortGatedCard({
    label: 'Total Overtime Hours',
    value: formatDashboardNumber(totalOtHours),
    changePrct: totalOtHoursChangePrct,
    isCohortSelected,
    hasError: totalOtHoursError,
    comparisonText,
  });

  const otRateCard = buildCohortGatedCard({
    label: 'Overtime Rate',
    value: `${formatDashboardNumber(otRate)}%`,
    changePrct: otRateChangePrct,
    isCohortSelected,
    hasError: otRateError,
    comparisonText,
  });

  return [totalOtHoursCard, otRateCard];
}
